module.exports = __webpack_public_path__ + "img/rent4.c49af03b.jpg";